import LanguageStringResolver from "../fields/language/LanguageStringResolver";
import React from "react";

export const renderInputField = (name, label, data, handleInputChange, type = "text", isRequired = false, isDisabled = false) => {
    const inputProps = {
        id: name,
        type,
        name,
        value: data[name],
        onChange: e => handleInputChange(e),
        'data-testid': `${name}-input`,
        disabled: isDisabled
    };

    return (
        <s-row>
            <s-col span="auto" data-testid={name}>
                <label htmlFor={name} className={isRequired ? "required" : ""}>
                    <LanguageStringResolver string={label} />
                </label>
                <input {...inputProps} pattern={type === 'number' ? "[0-9]*" : undefined} />
            </s-col>
        </s-row>
    );
};